import buttonDefaultSchema from '../../formComponents/button/defaultSchema';
import datetimeDefaultSchema from '../../formComponents/datetime/defaultSchema';
import fileDefaultSchema from '../../formComponents/file/fileDefaultSchema';
import numberDefaultSchema from '../../formComponents/number/defaultSchema';
import selectDefaultSchema from '../../formComponents/select/defaultSchema';
import textareaDefaultSchema from '../../formComponents/textarea/defaultSchema';
import textFieldDefaultSchema from '../../formComponents/textfield/defaultSchema';
import htmlElementDefaultSchema from '../../formComponents/htmlelement/defaultSchema';
import checkboxDefaultSchema from '../../formComponents/checkbox/defaultSchema';
/**
 * Components implemented in formways
 */
const defaultFormwaysSchema = {
  button: buttonDefaultSchema,
  datetime: datetimeDefaultSchema,
  file: fileDefaultSchema,
  number: numberDefaultSchema,
  select: selectDefaultSchema,
  textarea: textareaDefaultSchema,
  textfield: textFieldDefaultSchema,
  htmlelement: htmlElementDefaultSchema,
  checkbox: checkboxDefaultSchema
};

/**
 * Converts different forms of default values in formio schema to
 * standardised formways schema
 * @param {Object} component
 * @returns {Object}
 */
const processDefaultValue = component => {
  let defaultVal = '';
  if (component.type === 'file' || component.multiple) {
    defaultVal = [];
  }
  if (component.customDefaultValue) {
    return {
      type: 'customScript',
      script: component.customDefaultValue || defaultVal
    };
  }
  if (component.allowDefaultValueURL) {
    return {
      type: 'url',
      url: component.defaultValueURL || defaultVal
    };
  }
  // TODO: handle default value loaded using url
  return {
    type: 'value',
    value: component.defaultValue || defaultVal
  };
};

/**
 * Removes formio properties which are not defined in formways component
 * @param {Object} schema
 * @param {Object} defaultSchema
 */
const removeUnnecessaryProps = (schema, defaultSchema) => {
  const s = { ...schema };
  Object.keys(schema).forEach(key => {
    if (!(key in defaultSchema)) {
      delete s[key];
    }
  });
  return s;
};
const processFileComponent = schema => {
  // Removing the empty entry created by the builder
  const emptyValueIndex = schema.fileTypes.findIndex(item => item.value === '');
  schema.fileTypes.splice(emptyValueIndex, 1);
};
/**
 * removes the unnecessary props and formats the default value properly
 * @param {*} component
 * @param {*} defaultSchema
 */
const processDefaultValueAndRemoveUnnecessaryProps = (component, defaultSchema) => {
  const defaultValue = processDefaultValue(component);
  const schema = { ...defaultSchema, ...component };
  schema.defaultValue = defaultValue;
  if (schema.type === 'file') {
    processFileComponent(schema);
  }
  schema.type = `fw-${schema.type}`;
  return removeUnnecessaryProps(schema, defaultSchema);
};

/**
 * Converts a formio component to json which is compatible with formways
 * @param {Object} component
 * @returns Object
 */
export const formioToFormwaysComponent = component => {
  if (component.type in defaultFormwaysSchema) {
    return processDefaultValueAndRemoveUnnecessaryProps(
      component,
      defaultFormwaysSchema[component.type]
    );
  }
  return component;
};

/**
 * Converts the formio schema into formways schema
 * @param {Object} form
 */
const formioToFormways = (fioComponents, fwOriginalSchema) => {
  const fwComponents = [];
  // cloning the components to avoid reference issues
  const formioComponents = [...fioComponents];
  formioComponents.forEach(component => {
    if (component.type === 'columns') {
      const columns = [];
      component.columns.forEach(column => {
        columns.push(formioToFormways(column.components, column));
      });
      // eslint-disable-next-line
      component.columns = columns;
      // eslint-disable-next-line
      component.type = `fw-${component.type}`;
      fwComponents.push(component);
    } else {
      fwComponents.push(formioToFormwaysComponent(component));
    }
  });
  const formWaysSchema = { ...fwOriginalSchema };
  formWaysSchema.components = fwComponents;
  return formWaysSchema;
};

export default formioToFormways;
